import { ajax } from '../../../services/helper'
class ApiService {

    getEmployeePayScalesData = (from,to,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/list?from="+from+"&to="+to+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getEmployeePayScalesById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    validateEmployeePayScales = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/validateDeputy"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    getEmployeeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/view"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    addEmployeePayScales = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editEmployeePayScales = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeePromotions/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Employee Pay Scales/services/apiservices.js